import React, { useState, useEffect } from 'react';
import styles from './DeliveryRecords.module.scss';
import Tooltip from '@lingxi-common-component/sirius-ui/Tooltip';
import { TongyongJiazai } from '@sirius/icons';
import { useContactModel } from '@web-common/hooks/useContactModel';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { getIn18Text } from 'api';
import useStateRef from '@web-mail/hooks/useStateRef';
const ContactItem = props => {
    var _a, _b;
    const { email, status, listLength, _account, subAccount, hideSplit } = props;
    const getIconByStatus = (status) => {
        if (status == '0') {
            return (React.createElement(TongyongJiazai, { className: "sirius-spin" }));
        }
        if (status == '2') {
            return (React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                React.createElement("circle", { cx: "8", cy: "8", r: "7", fill: "#FE5B4C" }),
                React.createElement("path", { d: "M8 4.70001V9", stroke: "white", strokeLinecap: "round" }),
                React.createElement("path", { d: "M8.59844 11.1C8.59844 11.4314 8.32981 11.7 7.99844 11.7C7.66707 11.7 7.39844 11.4314 7.39844 11.1C7.39844 10.7686 7.66707 10.5 7.99844 10.5C8.32981 10.5 8.59844 10.7686 8.59844 11.1Z", fill: "white" })));
        }
    };
    const contactModel = useContactModel({ email, _account });
    const Icon = getIconByStatus(status);
    return (React.createElement(React.Fragment, null, status != 1 ? (React.createElement(Tooltip, { placement: "top", title: status == 0 ? getIn18Text('FENFAZHONGQSHSXCK') : getIn18Text('FENFASHIBQZXFF') },
        React.createElement("div", { className: `${styles.contact} ${status == '2' ? styles.recordError : ''}` },
            Icon ? React.createElement("div", { className: styles.contactIcon }, Icon) : null,
            React.createElement("div", { className: styles.name }, ((_a = contactModel === null || contactModel === void 0 ? void 0 : contactModel.contact) === null || _a === void 0 ? void 0 : _a.contactName) || ''),
            React.createElement("div", { className: styles.email }, subAccount || email),
            React.createElement("div", null, hideSplit ? null : '、')))) : (React.createElement("div", { className: `${styles.contact} ${status == '2' ? styles.recordError : ''}` },
        React.createElement("div", { className: styles.name }, ((_b = contactModel === null || contactModel === void 0 ? void 0 : contactModel.contact) === null || _b === void 0 ? void 0 : _b.contactName) || ''),
        React.createElement("div", { className: styles.email }, subAccount || email),
        React.createElement("div", null, hideSplit ? null : '、')))));
};
const WmMailDeliveryRecords = props => {
    const { recordInfo, onRefresh, _account } = props;
    const { distributeDetails } = recordInfo || {};
    const distributeDetailsRef = useStateRef(distributeDetails);
    const [isRefresh, setIsRefresh] = useState(true);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const handleRefesh = useCreateCallbackForEvent(() => {
        if (isRefresh)
            return;
        if (onRefresh) {
            const promise = onRefresh();
            if (promise) {
                setIsRefresh(true);
                promise.finally(() => {
                    setTimeout(() => {
                        setIsRefresh(false);
                    }, 1000);
                });
            }
        }
    });
    const handleDetailToggle = () => {
        setIsDetailOpen(!isDetailOpen);
    };
    useEffect(() => {
        setIsRefresh(false);
    }, [recordInfo]);
    useEffect(() => {
        if (distributeDetailsRef.current) {
            const intervalFunction = () => {
                handleRefesh();
            };
            const tick = () => {
                if (distributeDetailsRef.current) {
                    intervalFunction();
                    timerId = setTimeout(tick, 600000);
                }
            };
            let timerId = setTimeout(tick, 600000);
            return () => clearTimeout(timerId);
        }
    }, [distributeDetails]);
    return (React.createElement(React.Fragment, null, distributeDetails ? (React.createElement("div", { className: styles.infoWrap },
        React.createElement("div", { className: styles.titleWrap },
            React.createElement("div", { className: styles.left },
                React.createElement("div", { className: styles.logoWrap },
                    React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("circle", { cx: "8", cy: "8", r: "7", fill: "#0FD683" }),
                        React.createElement("path", { d: "M5.30078 8L7.4221 10.1213C7.4221 10.1213 9.741 7.80242 11.3112 6.23223", stroke: "white", strokeLinecap: "round", strokeLinejoin: "round" }))),
                React.createElement("div", { className: styles.title }, getIn18Text('FENFAJILYJYBFFC', { count: distributeDetails === null || distributeDetails === void 0 ? void 0 : distributeDetails.length })),
                React.createElement("div", { className: styles.detail, onClick: handleDetailToggle }, isDetailOpen ? getIn18Text('SHOUQI') : getIn18Text('XIANGQING'))),
            React.createElement("div", { className: styles.operWrap },
                React.createElement("div", { className: styles.refresh, onClick: handleRefesh }, isRefresh ? React.createElement(TongyongJiazai, { className: "sirius-spin" }) : getIn18Text('setting_system_switch_web')))),
        isDetailOpen ? (React.createElement("div", { className: styles.detailWrap }, distributeDetails === null || distributeDetails === void 0 ? void 0 : distributeDetails.map((item, index) => {
            var _a;
            return (React.createElement("div", { className: `${styles.record}` },
                React.createElement("div", { className: styles.iconWrap },
                    React.createElement("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                        React.createElement("path", { d: "M1.125 6C1.125 3.30761 3.30761 1.125 6 1.125V1.125C8.69239 1.125 10.875 3.30761 10.875 6V6C10.875 8.69239 8.69239 10.875 6 10.875V10.875C3.30761 10.875 1.125 8.69239 1.125 6V6Z", stroke: "#6F7485", strokeWidth: "0.75" }),
                        React.createElement("path", { d: "M5.625 3.375V6.375H7.875", stroke: "#6F7485", strokeWidth: "0.75", strokeLinecap: "round", strokeLinejoin: "round" }))),
                React.createElement("div", { className: styles.recordContent },
                    React.createElement("div", { className: styles.recordTitle }, item.date),
                    React.createElement("div", { className: styles.contactWrap }, (_a = item === null || item === void 0 ? void 0 : item.to) === null || _a === void 0 ? void 0 : _a.map((toItem, toIndex) => {
                        var _a, _b;
                        return (React.createElement(ContactItem, { email: toItem.account, status: toItem.status, subAccount: toItem.subAccount, _account: _account, listLength: (_a = item === null || item === void 0 ? void 0 : item.to) === null || _a === void 0 ? void 0 : _a.length, hideSplit: toIndex == ((_b = item === null || item === void 0 ? void 0 : item.to) === null || _b === void 0 ? void 0 : _b.length) - 1 }));
                    })))));
        }))) : null)) : null));
};
export default WmMailDeliveryRecords;
